<template>
    <OeeLayout v-if="layoutLoad" @needReload="reloadLayout"></OeeLayout>
    <div v-else style="background-color: #1B1534" :style="fullScreenStyle" id="background-cover">
        <div class="position-absolute d-flex flex-column " style="top: 50%; left: 50%; color: white;">
            <b-spinner class="ml-auto mr-auto"></b-spinner>
            <div>正在刷新...</div>
        </div>
    </div>
</template>

<script>
import OeeLayout from "@/components/echarts-part/tpm/oee/OeeLayout.vue";

export default {
    name: "OeeLayoutContainer",
    components: {OeeLayout},
    data() {
        return {
            layoutLoad: true,
            screenWidth: 0,
            screenHeight: 0
        }
    },
    computed: {
        fullScreenStyle() {
            return `width: ${this.screenWidth}px; height: ${this.screenHeight}px;`
        },
    },
    created() {
        this.setVisible(false);
    },
    beforeDestroy() {
        this.setVisible(true);
    },
    methods: {
        getScreenSize() {
            let {width, height} = screen
            this.screenWidth = width;
            this.screenHeight = height;
        },
        reloadLayout() {
            this.getScreenSize();
            this.layoutLoad = false;
            setTimeout(() => this.layoutLoad = true, 3000);
        },
        setVisible(visibility) {
            this.$store.commit("base/setShowHeader", visibility, {root: true});
            this.$store.commit("base/setShowSidebar", visibility, {root: true});
        },
    },
}
</script>

<style scoped>

</style>
